export default __webpack_public_path__ + "static/media/dmk.c2e098e0.webp";